import {AxiosRequest, HttpUtils} from '../../../utils/HttpUtils';
import {WECHAT_APP_ID} from "../../../constants/Profile";

export const WeChatAuthApi = {
    getOAuth2AccessToken: async (code: string) => {
        try {
            const params = new Map<string, string>();
            params.set('code', code);
            params.set('appId', WECHAT_APP_ID);
            const requestUrl = HttpUtils.addQueryString('/v1/wechat/auth/oAuth2AccessToken', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
